export default {"src":"/_next/static/media/drawing_bold.354d828f.svg","height":24,"width":24};